import React, { useState } from 'react'
import { format, parseISO } from 'date-fns'
import { useModal } from 'lib/hooks'

function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ''
}

function formatDate(isoString) {
  if (!isoString) return ''
  return format(parseISO(isoString), 'MM/dd/yy')
}

export default function DenialNoticeModal({ packageId, requestId, respondedAt, responseReason, decisionDueAt }) {
  const [acknowledged, setAcknowledged] = useState(false)
  const { modalRef } = useModal({ open: !acknowledged })

  async function handleAcknowledge() {
    setAcknowledged(true)
    try {
      const response = await fetch(`/package_hook/${packageId}/ny_1120b/extensions/custom_requests/acknowledge`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': getCsrfToken(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request_id: requestId }),
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
    } catch (e) {
      setAcknowledged(false)
      console.warn('DenialNoticeModal: failed to persist acknowledgement', e)
    }
  }

  return (
    <div ref={modalRef.ref} className="modal fade denial-notice-modal" tabIndex="-1" role="dialog" aria-modal="true" data-backdrop="static" data-keyboard="false">
      <div className="modal-dialog" role="document">
        <div className="modal-content dome-d-flex dome-flex-column dome-gap24">
          <div className="modal-header dome-d-flex dome-flex-column dome-gap12">
            <i className='fat fa-calendar-clock dome-color-red-alert' />
            <div className="modal-title dome-h2 dome-color-red-alert">deadline extension denied</div>
          </div>
          <div className="modal-body dome-d-flex dome-flex-column dome-gap12">
            <div className='dome-p1'>
              The applicant has denied the deadline extension. The decision is still due on <span className='dome-color-darkest-grey dome-text-w500'>{formatDate(decisionDueAt)}</span>.
            </div>
            <div className="dome-d-flex dome-flex-column dome-gap3">
              <div className='dome-p3 dome-color-med-grey'>denied {formatDate(respondedAt)}</div>
              <div className="dome-p2 dome-bg-fill dome-rounded-border dome-padding6-12">
                {responseReason ? (
                  <span className='dome-color-dark-grey'>{responseReason}</span>
                ) : (
                  <span className='dome-color-lite-grey'>no reason stated</span>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="dome-btn dome-btn-base dome-btn-aqua-stroke" onClick={handleAcknowledge}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
